var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginationSkip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2.0352211 3.1938019",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61.788286,-148.14967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pagination-arrow-left",
    transform: "matrix(0.26458333,0,0,0.26458333,61.921682,148.15496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CTA_Arrow_01",
    transform: "rotate(180,3.594,6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "m 6,0 6,6 H 0 Z",
    transform: "rotate(90,3,3)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rect233",
    width: 0.99214339,
    height: 12.071077,
    x: -0.50416929,
    y: -0.019990936,
    ry: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationSkip);
export default __webpack_public_path__ + "static/media/pagination-skip.f9816e2c48bbc343fc41742698da1b87.svg";
export { ForwardRef as ReactComponent };